module.exports = __webpack_public_path__ + "img/flag-fr.0ddd5d98.svg";